// Copyright (c) 2024 ParkEngage Inc. All rights reserved.

// This software is the confidential and proprietary information of
// ParkEngage Inc. ("Confidential Information"). You shall not
// disclose such Confidential Information and shall use it only in
// accordance with the terms of the license agreement you entered into
// with ParkEngage Inc.

// This source code is a valuable trade secret of ParkEngage Inc.

// THIS SOFTWARE IS PROVIDED BY ParkEngage Inc. ``AS IS'' AND ANY
// EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
// IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR
// PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL [YOUR COMPANY NAME] OR
// CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL,
// EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO,
// PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
// PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY
// OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
// (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE
// OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.

// The views and conclusions contained in the software and documentation
// are those of the authors and should not be interpreted as representing
// official policies, either expressed or implied, of ParkEngage Inc.

export const errorMessage = {
    somethingWentWrong: 'Something went wrong, Please try again!',
    invalidPartner: 'Invalid Garage, Please Enter a Valid Garage URL!',
    invalidFacility: 'Unable to Fetch Facility, Please Try Again!',
    notFound: 'PAGE NOT FOUND',
    loginNotes : 'You will need to log in or create an account to continue',
    registeration: 'Registration completed successfully. Please login!',
    noDataAvailable : 'No data Available!',
    invalidQrCode: 'Please scan the valid QR Code',
    validDuration: 'Please select a valid duration',
    validRateBand: 'Please select a Rate Band',
    validDurationRateBand: 'Please select a valid duration or Rate Band',
    activeCheckinMessage: 'We found an Active Check-in against this License Plate & Mobile Number. Do you want to check the details ?',
    facilityOprlMessage : 'The Facility is not operation at this moment.',
    awayMessage: 'Data was updated while you were away. Please refresh to see the changes.',
    errorinParams: 'URL is Malformed, Please try again.',
    rateBandnotAvailable: 'Something went wrong with rate bands, Please refresh and try again!',
    selectPaymewntMethod: 'Please select a Payment Method',
    rateRevisedMessage: 'We have revised your rates based on your entry time.',
    promoApplicableDisclaimer: '**If paying using Apple/Google Pay Promocode/Validation must be applied before the payment.',

}

export const paymentStoppedmsg = (device = false) => {
    return `You have initiated parking using ${device ? 'Google Pay' : 'Apple Pay'} Please ensure that you use the same device to extend your parking session.`
}